import { render, staticRenderFns } from "./carAddUpdate.vue?vue&type=template&id=05e9d7b4"
import script from "./carAddUpdate.vue?vue&type=script&lang=js"
export * from "./carAddUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports